<template>
  <div class="social is-flex">
    <a href="https://www.facebook.com/SodaLabsHQ" target="_blank" class="is-relative">
      <span class="underline is-block is-demi-bold fadeInLeft">Facebook</span>
    </a>
    <a href="https://www.linkedin.com/company/sodalabs/" target="_blank" class="is-relative">
      <span class="underline is-block is-demi-bold fadeInLeft">LinkedIn</span>
    </a>
    <a href="https://www.behance.net/sodalabs" class="is-relative"
      ><span class="underline is-block is-demi-bold fadeInLeft">Behance</span>
    </a>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.social {
  position: absolute;
  bottom: 32px;
  left: 32px;
  a {
    font-size: 18px;
    text-decoration: none;
    letter-spacing: -0.3px;
    color: rgba(255, 255, 255, 0.3);
    &:hover {
      color: $color-white;
    }
    &:not(:last-child) {
      padding-right: 32px;
      span {
        &:before {
          content: '';
          position: absolute;
          width: 2px;
          height: 2px;
          background: rgba(255, 255, 255, 0.3);
          right: -16px;
          top: calc(50% - 1px);
        }
      }
    }
  }
}
</style>
